import { gridsNames } from '../../../enums/gridsNames';
import * as gridActionsHelper from '../../../../../infrastructure/js/components/Grid/Utils/gridActionsHelper';
import * as sensorProvidersService from '../../../services/SensorProviders/sensorProvidersService';

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_SETTINGS_TRUCKS_SENSORS, _fetchDataAction);

function _fetchDataAction(query) {
  return function (dispatch, getState) {
    return sensorProvidersService.fetchSensorProviderConfigsGrid(query);
  };
}

export let actionTypes = gridActions.actionTypes,
  api = gridActions.apiActions,
  jsxActions = gridActions.jsxActions;
